import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import app from './modules/app'
import master from './modules/master'
import order from './modules/order'
import im from './modules/im'
import gameRoom from './modules/game-room'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    master,
    order,
    im,
    gameRoom
  },
  getters
})

export default store